export var appConfig = {
  insaServiceAddress: "https://www.insa-support.com/InsaWebApi/api",
  authServiceAddress: "https://www.insa-support.com/InsaWebApi",
  pivotViewerServiceAddress: "https://www.insa-support.com/InsaWebApi"
  // insaServiceAddress: "http://localhost:51438/api",
   //authServiceAddress: "http://localhost:51438",
  //insaServiceAddress: "http://192.168.168.69:51438/api",
  //authServiceAddress: "http://192.168.168.69:51438",
  //pivotViewerServiceAddress: "http://192.168.168.69:51438"
}


// WEBPACK FOOTER //
// ./insa-css/insa-clients/Insa/insaweb.service.config.ts